<div class="lvi-content">
    <div class="avatar">
        <i class="material-icons-outlined">assignment</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a (click)="onSelect()">{{ data.dateApplication | date:'shortDate' }}</a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.frais.prestations.detail.reglesGestion.remboursement.montant.popin.montant'"></strong>
                <span>{{ data.taux | number:'1.0-2' }}</span>
            </li>
            <li>
                <strong [translate]="'admin.frais.prestations.detail.reglesGestion.remboursement.montant.popin.devise'"></strong>
                <span>{{ liste.extraOptions.devise }}</span>
            </li>
        </ul>
    </div>
    <div class="lvi-actions">
        <button mat-icon-button (click)="deleteMontant()" [matTooltip]="'global.actions.supprimer' | translate">
            <i class="nio icon-suppression"></i>
        </button>
    </div>
</div>